import { render, staticRenderFns } from "./StatisticsModal.vue?vue&type=template&id=5a918f60&"
import script from "./StatisticsModal.vue?vue&type=script&lang=js&"
export * from "./StatisticsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports